// @flow

import { type ActionType, createAction, handleAction } from 'redux-actions'
import type { Municipality } from 'sources/types'
import { map } from 'd3-collection'
import type { D3Map } from 'components/choroplethMap/choroplethMapComponent'

/**
 * The Municipality definition
 */

/**
 * Action for updating the map with new data
 */
export const rentPricesUpdate = createAction(
  'RENT_PRICES/UPDATE',
  (gemeinden: Array<Municipality>) => gemeinden
)

/**
 * Reducer for rent prices by municipality
 */
export const rentPricesByMunicipality: (
  state: D3Map<Municipality>,
  action: ActionType<typeof rentPricesUpdate>
) => D3Map<Municipality> = handleAction(
  rentPricesUpdate,
  (state, { payload }: ActionType<typeof rentPricesUpdate>) => {
    return map(payload, (d: Municipality) => d.municipalityID.toString())
  },
  map([], d => d.municipalityID)
)

/**
 * Action for setting the active municipality on the map
 */
export const mapActiveMunicipality = createAction(
  'MAP/ACTIVE_MUNICIPALITY',
  (id: number) => id
)

export const activeMunicipality: (
  state: number,
  action: ActionType<typeof mapActiveMunicipality>
) => number = handleAction(
  mapActiveMunicipality,
  (state, { payload }: ActionType<typeof mapActiveMunicipality>) => payload,
  -1
)
